import { Suspense, lazy, useState } from "react";
import type { CommentAttachment } from "../../../types";
import FileCard from "./FileCard";

const ImageViewer = lazy(() => import("@/shared/ui/ImageViewer"));

interface Props {
  attachments: CommentAttachment[];
}

export default function CommentAttachments({ attachments }: Props) {
  const [viewingImage, setViewingImage] = useState<{ url: string; name: string } | null>(null);

  function handleClick(attachment: CommentAttachment) {
    if (attachment.content_type.startsWith("image/")) {
      setViewingImage({ url: attachment.file_url, name: attachment.file_name });
    } else {
      window.open(attachment.file_url, "_blank");
    }
  }

  return (
    <>
      <div className="mt-2 flex flex-wrap gap-2">
        {attachments.map((att) => (
          <FileCard
            key={att.id}
            name={att.file_name}
            size={att.file_size}
            contentType={att.content_type}
            onClick={() => handleClick(att)}
          />
        ))}
      </div>

      {viewingImage && (
        <Suspense fallback={null}>
          <ImageViewer
            imageUrl={viewingImage.url}
            fileName={viewingImage.name}
            onClose={() => setViewingImage(null)}
          />
        </Suspense>
      )}
    </>
  );
}
